import { render, staticRenderFns } from "./ActivityListView.vue?vue&type=template&id=031fc7f5&scoped=true"
import script from "./ActivityListView.vue?vue&type=script&lang=js"
export * from "./ActivityListView.vue?vue&type=script&lang=js"
import style0 from "./ActivityListView.vue?vue&type=style&index=0&id=031fc7f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031fc7f5",
  null
  
)

export default component.exports